<template>
  <div id="app">
    <lottie :options="defaultOptions" :height="400" :width="400" v-on:animCreated="handleAnimation"/>

    <a href="ycstock://stock?codes=600600" style="font-size: 20px">600600</a>


    <div class="sepBottom" style="margin-top: 30px;position: relative">sepBottom</div>
    <div class="sepTop" style="margin-top: 30px;position: relative">sepTop</div>


  </div>


</template>

<script>

import animationData from "../../lottie/voice-bar.json";
import lottie from 'vue-lottie';

export default {
  components:{
    lottie
  },
  methods: {
    handleAnimation (anim) {
      this.anim = anim;
    }
  },
  data() {
    return {
      defaultOptions: {animationData: animationData},
      animationSpeed: 1,
      anim: {}
    }
  },
};
</script>

<style>
.text {
  text-align: center;
  font-size: 40px;
  color: #ffffff;
  line-height: 200px;
}





</style>
